import React, {useEffect, useMemo, useState} from 'react'
import PostSearchContainer from './PostSearchContainer'
import PostListTable from './PostListTable'
import useQueryPostList from '../../../../hooks/api/post/useQueryPostList'
import {IPostList} from '../../../../apis/post/getPostList'
import {useNavigate, useSearchParams} from 'react-router-dom'
import WizPagination from '../../../../components/pagination/WizPagination'
import {useInputCheck} from '../../../../utils/etc'
import useDidMountEffect from '../../../../hooks/useDidMountEffect'

interface IProps {
    className?: string
}

const PostListContainer: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryKeyword = searchParams.get('keyword')
    const queryId = searchParams.get('search_id')
    const navigate = useNavigate()
    const [searchWord, setSearchWord] = useState(queryKeyword || '')
    const [searchId, setSearchId] = useState(queryId || '')
    const [currentPage, setCurrentPage] = useState(1)
    const [searchTarget, setSearchTarget] = useState(queryKeyword ? 'post' : queryId ? 'user' : 'post')
    const {data, refetch} = useQueryPostList(searchWord, 10, currentPage, searchId)

    const {checkList, onCheckedFunction, resetCheckList, onChangeCheckList} = useInputCheck()

    const postList = useMemo(() => {
        let list: IPostList[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        setCurrentPage(Number(currentPageParams) || 1)
    }, [])

    useDidMountEffect(() => {
        if (searchId) {
            navigate(`/post?search_id=${searchId}`)
        } else if (searchWord) {
            navigate(`/post?keyword=${searchWord}`)
        } else if (searchWord === '' || searchId === '') {
            navigate(`/post`)
        }
        refetch()
    }, [searchWord, searchId])

    useDidMountEffect(() => {
        setSearchWord('')
        setSearchId('')
    }, [searchTarget])

    useEffect(() => {
        refetch()
        resetCheckList()
    }, [currentPage])

    const onClickAllBanUser = () => {
        const arr = []
        postList?.map(item => {
            if (item?.user?.is_filtered) {
                arr.push(item?.id)
            }
        })

        onChangeCheckList(arr)
    }

    const searchList = useMemo(() => {
        return [
            {id: 'post', value: 'Post'},
            {id: 'user', value: 'User_ID'},
        ]
    }, [])

    return (
        <>
            <PostSearchContainer
                checkList={checkList}
                search={searchWord || searchId}
                searchList={searchList}
                onChangeSearchTarget={e => setSearchTarget(e)}
                searchTarget={searchTarget}
                onClick={e => {
                    if (searchTarget === 'post') {
                        setSearchWord(e)
                        setSearchId('')
                    } else {
                        setSearchId(e)
                        setSearchWord('')
                    }
                }}
                onClickAllBanUser={onClickAllBanUser}
            />
            <PostListTable
                data={postList}
                className={'mt-[30px]'}
                checkList={checkList}
                onChecked={e => onCheckedFunction(e)}
            />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => {
                    setCurrentPage(item)
                    window.history.pushState('', '', `?page=${item}`)
                }}
            />
        </>
    )
}

export default PostListContainer
